import React from 'react'
import { Link } from 'react-router-dom'
import { NavigationRoutes } from '../../Constants/Routes'
import { isDemoEnabled } from '../../Utility/UserUtils'

const LibrarySummary = () => {
  const IsDemoFeatureEnabled = isDemoEnabled();
  return (
    <>
      <h1>Library</h1>
      {/* <p>
        Access your saved selections to download files in desired formats and reuse, rename, or delete your data selections.
      </p>
      <p>
        Processing times vary depending on the size of your data selection. For assistance, visit the{' '}
        <Link to={NavigationRoutes.SUPPORT.FAQs}>Support</Link> page or contact our team:<br /><br />
        Technical assistance and General questions: {<a href="mailto:performancelens_growthcube@mckinsey.com">performancelens_growthcube@mckinsey.com</a>}<br />
      </p> */}
    </>
  )
}

export default LibrarySummary
